import {
  getProductConfigurationJsonApi,
  postProductConfigurationJsonApi,
  getConfigVersionsApi,
  getConfigByVersionApi,
  putConfigLiveApi,
  postConfigUploadOverwriteApi,
} from "../api/productConfiguration";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { queryKey } from "../constants/queryKey";

export const usePostConfigurationJson = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: postProductConfigurationJsonApi,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [queryKey.getConfigurationJsonContent],
      });
      toast.success("Product configuration JSON has been uploaded");
    },
  });
};
export const useGetProductConfigurationJson = () => {
  return useQuery({
    queryKey: [queryKey.getConfigurationJsonContent],
    queryFn: getProductConfigurationJsonApi,
  });
};

export const useGetConfigMutation = () => {
  return useMutation({
    mutationFn: getProductConfigurationJsonApi,
  });
};

export const useGetConfigVersions = () => {
  return useQuery({
    queryKey: [queryKey.getConfigVersions],
    queryFn: getConfigVersionsApi,
  });
};

export const useGetConfigByVersion = () => {
  return useMutation({
    mutationFn: getConfigByVersionApi,
  });
};

export const usePutConfigLive = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: putConfigLiveApi,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [queryKey.getConfigurationJsonContent],
      });
    },
  });
};

export const usePostConfigUploadOverwrite = () => {
  return useMutation({
    mutationFn: postConfigUploadOverwriteApi,
  });
};